/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const LampFloor = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M9 2h6l3 7H6l3-7Z" }],
    ["path", { d: "M12 9v13" }],
    ["path", { d: "M9 22h6" }]
  ]
];

export { LampFloor as default };
//# sourceMappingURL=lamp-floor.js.map
